import { library } from '@fortawesome/fontawesome-svg-core'

import { faAward, faTrophy, faChildReaching, faIceCream, faHand, faPencil, faArrowLeft, faBroom, faHandSparkles ,faStar, faCircleCheck, faSchool, faBookOpen, faBook, faBath, faChessBoard, faAppleWhole, faTv, faGamepad, faPuzzlePiece, faHeart, faBowlingBall, faGolfBall, faBaseballBatBall, faTableTennisPaddleBall, faFootball, faBasketball, faSoccerBall, faMoneyBillWave, faPen, faFaceSmileBeam, faPaintBrush, faPizzaSlice } from '@fortawesome/free-solid-svg-icons'

export function initIcons() {
    library.add(
        faAward,
        faHand,
        faTrophy, 
        faChildReaching, 
        faIceCream, 
        faPencil, 
        faArrowLeft,
        faStar,
        faBroom,
        faBath,
        faHandSparkles,
        faStar,
        faCircleCheck,
        faSchool,
        faBookOpen,
        faBook,
        faChessBoard,
        faAppleWhole,
        faTv,
        faGamepad,
        faPuzzlePiece,
        faHeart,
        faBowlingBall,
        faGolfBall,
        faBaseballBatBall,
        faTableTennisPaddleBall,
        faFootball,
        faBasketball,
        faSoccerBall,
        faMoneyBillWave,
        faPen,
        faPencil,
        faFaceSmileBeam,
        faPaintBrush,
        faPizzaSlice
    )
}

export const taskIcons = [
   'award',
   'bath',
   'broom',
   'hand-sparkles',
   'star',
   'pen',
   'circle-check',
   'school',
   'trophy',
   'pizza-slice',
   'gamepad',
   'chess-board',
   'apple-Whole',
   'tv',
   'puzzle-piece',
   'heart',
   'bowling-ball',
   'golf-ball',
   'baseball-bat-ball',
   'table-tennis-paddle-ball',
   'foot-ball',
   'basket-ball',
   'soccer-ball',
   'money-bill-wave',
   'book',
   'book-open',
   'face-smile-beam',
   'paintbrush'
].sort()

export const rewardIcons = [
    'award', 
    'hand',
    'book',
    'book-open',
    'trophy',
    'child-reaching',
    'ice-cream',
    'star',
    'pizza-slice',
    'gamepad',
    'puzzle-piece',
    'heart',
    'chess-board',
    'apple-Whole',
    'tv',
    'gamepad',
    'puzzle-piece',
    'heart',
    'bowling-ball',
    'golf-ball',
    'baseball-bat-ball',
    'table-tennis-paddle-ball',
    'foot-ball',
    'basket-ball',
    'soccer-ball',
    'money-bill-wave',
    'face-smile-beam',
    'paintbrush'
].sort()